import React from 'react';
import { MarketingShell } from '@/seo/kit';

const Disclaimer = () => {
  return (
    <MarketingShell>
      <section style={{ background: '#EEF2F8' }}>
        <div className="max-w-4xl mx-auto px-5 md:px-8 py-14 md:py-20">
          <h1 className="text-4xl md:text-5xl" style={{ color: '#13294B', fontWeight: 800, letterSpacing: '-0.02em' }}>DRAWREADY — DISCLAIMER</h1>
          <p className="mt-3" style={{ color: '#5B6678' }}>Last Updated: January 1, 2026</p>
        </div>
      </section>
      <div className="max-w-4xl mx-auto px-5 md:px-8 py-14 md:py-20 space-y-8">

          {/* Important Notice */}
          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-900">Important Notice</h2>
            <p className="text-slate-600 leading-relaxed font-semibold text-lg">
              DrawReady is a software platform only.
            </p>
            
            <div className="border border-slate-200 rounded-md p-5">
              <p className="text-slate-900 font-medium mb-3">DrawReady does not:</p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 ml-4">
                <li>Provide lending, banking, escrow, or payment services</li>
                <li>Guarantee approval, timing, or reimbursement of construction loan draws</li>
                <li>Act as a lender, financial institution, fiduciary, or advisor</li>
                <li>Underwrite, evaluate, or influence creditworthiness or lending decisions</li>
              </ul>
            </div>

            <p className="text-slate-600 leading-relaxed">
              Use of DrawReady does not create any fiduciary, advisory, partnership, or agency relationship between you and DrawReady.
            </p>
            <p className="text-slate-600 leading-relaxed font-medium">
              All lending decisions are made solely by third parties, including banks, lenders, or financial institutions.
            </p>
          </section>

          {/* Nature of the Platform */}
          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-900">Nature of the Platform</h2>
            <p className="text-slate-600 leading-relaxed">
              DrawReady is a project management and documentation tool designed to assist real estate developers and construction professionals with organizing and preparing information related to construction projects.
            </p>
            <p className="text-slate-600 leading-relaxed">The Platform may be used to:</p>
            <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
              <li>Track construction costs, budgets, and project phases</li>
              <li>Organize contractor and project-related data</li>
              <li>Generate standardized documentation for draw requests</li>
              <li>Store and manage project-related financial records and files</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mt-4 font-medium">
              DrawReady provides organizational tools only and does not verify, validate, or certify the accuracy, completeness, or acceptability of any documentation generated.
            </p>
          </section>

          {/* No Professional Advice */}
          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-900">No Professional Advice</h2>
            <div className="border border-slate-200 rounded-md p-5">
              <p className="text-slate-700 font-medium">
                DrawReady does not provide legal, tax, accounting, financial, or construction advice.
              </p>
            </div>
            <p className="text-slate-600 leading-relaxed">
              Any information or outputs generated by the Platform are for informational and organizational purposes only. You are responsible for consulting qualified professionals before making financial, legal, or construction-related decisions.
            </p>
          </section>

          {/* User Responsibility */}
          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-900">User Responsibility</h2>
            <p className="text-slate-600 leading-relaxed">
              You acknowledge and agree that you are solely responsible for:
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
              <li>The accuracy, completeness, and legality of all data entered into the Platform</li>
              <li>Reviewing and verifying all reports, documents, and outputs generated</li>
              <li>All communications with lenders, banks, and financial institutions</li>
              <li>Compliance with applicable laws, regulations, and contractual obligations</li>
              <li>Determining whether Platform outputs meet lender or third-party requirements</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mt-4 font-medium">
              DrawReady assumes no responsibility for errors, omissions, or outcomes resulting from user-provided information or third-party decisions.
            </p>
          </section>

          {/* No Guarantees */}
          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-900">No Guarantees</h2>
            <p className="text-slate-600 leading-relaxed">
              DrawReady makes no guarantees or representations regarding:
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
              <li>Approval or timing of construction loan draws</li>
              <li>Acceptance of documentation by lenders or third parties</li>
              <li>Financial outcomes, project success, or cost savings</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mt-4 font-semibold">
              Use of the Platform is at your own risk.
            </p>
          </section>

          {/* Relationship to Other Agreements */}
          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-slate-900">Relationship to Other Agreements</h2>
            <p className="text-slate-600 leading-relaxed">
              This Disclaimer supplements and operates in conjunction with DrawReady's:
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
              <li><a href="/terms" className="text-blue-600 hover:underline">Terms of Service</a></li>
              <li><a href="/privacy" className="text-blue-600 hover:underline">Privacy Policy</a></li>
            </ul>
            <p className="text-slate-600 leading-relaxed mt-4">
              In the event of any conflict, the Terms of Service shall govern.
            </p>
          </section>

        </div>
    </MarketingShell>
  );
};

export default Disclaimer;
